//service images
import city from '../assets/city_transportation.png'
import loader from '../assets/loader.png'
import garbage_card from '../assets/garbage_card.png'
import removal from '../assets/removal.png'

//price images
import van1 from '../assets/van1.png'
import van15 from '../assets/van15.png'
import van2 from '../assets/van2.png'
import van25 from '../assets/van25.png'
import van3 from '../assets/van3.png'
import van5 from '../assets/van5.png'
import loaderPrice from '../assets/loader_price.jpg'
import floor from '../assets/floor.jpg'
import garbage from '../assets/garbage.jpg'

export const MAIN_ROUTE = '/'

export const TELEPHONE_NUMBER = '+375 44 538-15-85'
export const HREF_TELEPHONE_NUMBER = '+375445381585'
export const EMAIL = 'GRUZOPEREVOZKI@gmail.com'

export const SERVICES = [
  {
    title: 'ПЕРЕЕЗД КВАРТИРЫ, ОФИСА В МИНСКЕ',
    description: 'Мы предоставляем услуги квартирных и офисных переездов с участием опытных и квалифицированных грузчиков. Наши специалисты не только аккуратно упакуют и надежно транспортируют ваше имущество, но и обеспечат бережное обращение с мебелью и техникой на каждом этапе.',
    img: removal
  },
  {
    title: 'ПРОФЕССИОНАЛЬНЫЕ ГРУЗЧИКИ',
    description: 'Мы предоставляем услуги профессиональных грузчиков. Наши сотрудники аккуратно и быстро выполнят погрузку и разгрузку ваших вещей, будь то мебель, техника или любые другие грузы. ругие грузы. Грузчики имеют опыт работы с различными типами грузов и помогут вам сэкономить время и силы при переезде или доставке.',
    img: loader
  },
  // {
  //   title: 'ПЕРЕВОЗКИ ПО МИНСКУ И БЕЛАРУСИ',
  //   description: 'Идеальное решение для доставки грузов по Минску и РБ. Мы обеспечиваем быстрые и безопасные перевозки грузов в пределах города, области и по всей стране. Наша команда гарантирует оперативность и внимание к каждому заказу.',
  //   img: city
  // },
  {
    title: 'ВЫНОС МУСОРА',
    description: 'Оперативно вывезем строительный мусор с вашего объекта, чтобы не задерживать процесс работы. Предоставляем вместительные контейнеры и гарантируем своевременное обслуживание на всех этапах стройки.',
    img: garbage_card
  },
]

export const ADD_PRICES = [
  {
    title: 'БУС ДО 1 ТОННЫ ОБЪЁМ ДО 10 КУБ. МЕТРОВ',
    price1: 'от 60 руб за 2 часa',
    price2: 'от 0,9 руб/км за городом',
    description: 'При работе в ночное время (22:00 - 6:00) надбавка к цене от 20%',
    img: van1, 
  },
  {
    title: 'ФУРГОН ДО 1,5 ТОНН ОБЪЁМ 11-15 КУБ. МЕТРОВ',
    price1: 'от 70 руб за 2 часa',
    price2: 'от 1,0 руб/км за городом',
    description: 'При работе в ночное время (22:00 - 6:00) надбавка к цене от 20%',
    img: van15,
  },
  {
    title: 'ФУРГОН ДО 2 ТОНН ОБЪЁМ 16-20 КУБ. МЕТРОВ',
    price1: 'от 80 руб за 2 часa',
    price2: 'от 1,2 руб/км за городом',
    description: 'Габариты: в т.ч. груз длиной до 6м, не более 0,5т, который может "свисать". \nПри работе в ночное время (22:00 - 6:00) надбавка к цене от 20%',
    img: van2,
  },
  {
    title: 'ФУРГОН ДО 2,5 ТОНН ОБЪЁМ 21-25 КУБ. МЕТРОВ',
    price1: 'от 120 руб за 3 часa',
    price2: 'от 1,3 руб/км за городом',
    description: 'При работе в ночное время (22:00 - 6:00) надбавка к цене от 20%',
    img: van25,
  },
  {
    title: 'ФУРГОН ДО 3 ТОНН ОБЪЁМ ДО 26-30 КУБ. МЕТРОВ',
    price1: 'от 150 руб за 3 часa',
    price2: 'от 1,4 руб/км за городом',
    description: 'Габариты: в т.ч. груз длиной 6 м, 0,5-2 т, который может «свисать». \nПри работе в ночное время (22:00 - 6:00) надбавка к цене от 20%',
    img: van3,
  },
  {
    title: 'ФУРГОН ДО 5 ТОНН ОБЪЁМ ДО 30 КУБ. МЕТРОВ',
    price1: 'от 220 руб за 4 часa',
    price2: 'от 1,8 руб/км за городом',
    description: 'Габариты: в т.ч. длина машины от 6 метров; груз длиной 6 м, свыше 2 т. \nПри работе в ночное время (22:00 - 6:00) надбавка к цене от 20%',
    img: van5,
  }
];

export const  MAIN_PRICES = [
  {
    title: 'ГРУЗЧИК',
    price1: 'На полноценные переезды: от 40 руб за 2 часа',
    price2: 'Для мелких работ: от 15 руб за 1 час',
    description: '- на полноценные переезды (в т. ч. работы, которые не делаются за 1 час) от 20 руб час; для мелких работ, например одна единица с лифтами, – от 15 руб час \n- при выезде на регион время в дороге от 10 руб час',
    img: loaderPrice,
  },
  {
    title: 'ПОЭТАЖКА',
    price1: 'от 35 руб/тонна за 1 этаж',
    price2: 'с лифтом - цена как за 2 этажа',
    description: `1 мешок (пачка)/этаж – 15..25..30..40..50 кг : 60..70..80..120..140 коп/эт
                  1 лист гипсокартона/этаж – 2,5..2,75..3м : 1,3..1,5..1,7 руб/эт
                  Вынос мусора – от 1 р мешок /этаж
                  Пианино – от 20 руб/эт, мининум 5`,
    img: floor,
  },
  {
    title: 'ВЫНОС МУСОРА',
    price1: 'До 1 тонны – от 100 р',
    price2: 'До 2 тонн – от 150 р',
    description: `Догруз, без жестких сроков, до 500 кг – от 70 р
                  До 1 тонны – от 100 р
                  До 2 тонн – от 150 р
                  До 3 тонн – от 200 р
                  До 5 тонн – от 300 р
                  при наличии в мусоре дерева и прочего проблемного в утилизации – цена выше`,
    img: garbage,
  },
]

export const ABOUT_DESCKTOP = {
  p1: 'Наша компания — это профессиональный подход к грузоперевозкам, надёжность и высокий уровень сервиса. Мы успешно работаем на рынке уже более 10 лет, обеспечивая качественную и своевременную доставку грузов любой сложности по Минску, области и всей Республике Беларусь.',
  p2: 'Мы гордимся тем, что наши клиенты доверяют нам не только перевозку вещей, но и свой покой. Благодаря слаженной работе команды и широкому автопарку, мы предлагаем решения для самых разных задач — от небольших квартирных переездов до масштабных грузоперевозок по стране.',
  p3: 'Доверьте свой груз профессионалам — мы заботимся о том, чтобы каждая доставка оставляла только положительные эмоции!',
} 

export const ABOUT_MOBILE = {
  p1: 'Опытная команда: мы занимаемся грузоперевозками уже более 10 лет.',
  p2: 'Широкий парк транспорта: от газелей до фур и спецтехники',
  p3: 'Фокус на безопасность: мы заботимся о сохранности вашего груза на всех этапах доставки.',
  p4: 'Доступные цены: мы предлагаем лучшие цены в регионе без потери качества услуг.'
}

export const FOOTER_TEXT = 'Профессианальные услуги по грузоперевозкам по Минску и Беларуси'